import { deleteExceptions, getAllExceptions } from "../../../../redux/specialist-slices/availability.slice";
import { refresher, showDialogWithData } from "../../../../redux/guest-slices/other.slice";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ADD_EXCEPTION } from "../../../../utils/keywords";
import TimeUtils from "../../../../utils/time.utils";
import Icons from "../../../../assets/js/Icons";

import {
  Box, Button, IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow
} from "@mui/material";

function Exceptions() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const { refresh } = useSelector(state => state.otherSlice);
  const { connectStatus } = useSelector((state) => state.walletSlice);

  const handleretrieveAll = async () => {
    const { data } = await dispatch(getAllExceptions()).unwrap() || {}
    if (data?.exceptions) setData(data?.exceptions)
  };

  const handleDelete = useCallback(async (id) => {
    const { success } = await dispatch(deleteExceptions(id)).unwrap() || {}
    if (success) dispatch(refresher())
    // eslint-disable-next-line
  }, []);

  const handleAddException = () => {
    dispatch(showDialogWithData({
      type: ADD_EXCEPTION,
    }))
  }

  const handleUpdateException = (exception) => {
    dispatch(showDialogWithData({
      type: ADD_EXCEPTION,
      data: { exception }
    }))
  }

  useEffect(() => {
    handleretrieveAll()
    // eslint-disable-next-line
  }, [refresh])

  const isStripeConnected =
    connectStatus?.connected === true &&
    connectStatus?.chargesEnabled === true &&
    connectStatus?.payoutsEnabled === true &&
    connectStatus?.onboardingComplete === true &&
    !!connectStatus?.stripeAccountId;

  return (
    <>
      <Box mb={3} sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Box />
        <Button
          size="small"
          variant="contained"
          onClick={handleAddException}
          startIcon={<Icons.PlusSolid />}
          disabled={!isStripeConnected}
        >Add exception
        </Button>
      </Box>

      <TableContainer variant="tableViewA">
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Date", "Time", "Actions"]?.map((element, i) => (
                <TableCell key={i} align="left">{element}</TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {!!data?.length ?
              data?.map((element) => (
                <TableRow key={element?._id}>
                  <TableCell>{TimeUtils.formatToOnlyDate(element?.start)}</TableCell>
                  <TableCell>
                    {element?.fullDay ? "Full day" : `${TimeUtils.formatTo12Hour(element?.start)} — ${TimeUtils.formatTo12Hour(element?.end)}`}
                  </TableCell>
                  <TableCell>
                    <IconButton sx={{ mr: 1 }} size="small" onClick={() => (handleUpdateException(element))}>
                      <Icons.EditSolid color="error" />
                    </IconButton>
                    <IconButton size="small" onClick={() => (handleDelete(element?._id))}>
                      <Icons.DeleteSolid color="error" />
                    </IconButton>
                  </TableCell>
                </TableRow>)) :
              <TableRow>
                <TableCell colSpan={3} align="center">No records found!</TableCell>
              </TableRow>
            }
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default Exceptions;